import React from "react";
import {
  turnstileManagedTokenKey,
  turnstileURL,
} from "../../utils/variables/variableData";

// Function for re-call
export function resetTurnstileWidget() {
  if (window.turnstile && typeof window.turnstile.reset === "function") {
    try {
      window.turnstile.reset();
    } catch (err) {
      console.warn("Turnstile reset failed:", err);
    }
  }
}

const TurnstileWidget = React.forwardRef(({ setToken }, ref) => {
  const containerRef = React.useRef(null);
  const widgetId = React.useRef(null);

  React.useEffect(() => {
    const renderWidget = () => {
      if (!window.turnstile || !containerRef.current) return;
      widgetId.current = window.turnstile.render(containerRef.current, {
        sitekey: turnstileManagedTokenKey,
        theme: "light",
        size: "flexible",
        callback: (token) => {
          if (setToken) setToken(token);
        },
        "error-callback": (error) => {
          console.error(`Widget ${widgetId} error:`, error);
          // if (onError) onError(error, widgetId);
        },
        "expired-callback": () => setToken(null),
      });
    };
    if (window.turnstile) renderWidget();
    else {
      const script = document.createElement("script");
      script.src = turnstileURL;
      script.async = true;
      script.defer = true;
      script.onload = renderWidget;
      document.body.appendChild(script);
    }

    return () => {
      if (widgetId.current) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
  }, [setToken]);

  React.useImperativeHandle(ref, () => ({
    execute: () => {
      if (widgetId.current) window.turnstile.execute(widgetId.current);
    },
    remove: () => {
      if (widgetId.current) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    },
    reset: () => {
      if (widgetId.current) window.turnstile.reset(widgetId.current);
    },
  }));

  return (
    <div
      style={{
        margin: 0, // remove side margins
        padding: "0 8px", // optional small inner padding
        textAlign: "center", // centers inner widget
        height: "65px",
      }}
      ref={containerRef}
      id="turnstile-container"
    />
  );
});

export default TurnstileWidget;
